import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout";
import Users from "../Users";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert2";

export default function AddUsers() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    language: null
  });
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState();

  const onSubmitChange = async e => {
    e.preventDefault();
    try {
      const responce = await axios.post("/api/v1/users/add", formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      swal.fire("Success!", "User has been successfully created.", "success");
      navigate("/users");
    } catch (error) {
      swal.fire({
        title: "Unable to add user",
        text: error.response.data.message,
        icon: "error",
      });
    }
  };

  const handleChange = event => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const ClicktoBack = () => {
    navigate("/users");
  };

  const FetchLanguage = () => {
    axios
      .get(`/api/v1/languages`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(response => {
        //console.log(response.data.results);
        setLanguages(response.data.results);
      })
      .catch(error => {
        swal.fire({
          title: "Unable to fetch data - Languages",
          text: error.message,
          icon: "error",
        });
      });
  };

  const handleLanguageSelect = (id) => {
    setFormData({ ...formData, language: Number(id) })
  }

  useEffect(() => {
    FetchLanguage();
  }, []);

  if (loading) {
    return <Users />;
  }

  return (
    <Layout>
      <div className="page-content">
        <div className="row">
          <div className="col-md-6 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <h6 className="card-title">Add User</h6>
                <form onSubmit={e => onSubmitChange(e)} className="forms-sample">
                  <div className="mb-3">
                    <label htmlFor="exampleInputUsername1" className="form-label">
                      Full Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name || ""}
                      onChange={handleChange}
                      className="form-control"
                      id="exampleInputUsername1"
                      autoComplete="off"
                      placeholder="Full Name"
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      Email address
                    </label>
                    <input type="email" name="email" value={formData.email || ""} onChange={handleChange} className="form-control" id="exampleInputEmail1" placeholder="Email" />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="exampleInputPassword1" className="form-label">
                      Password
                    </label>
                    <input
                      type="password"
                      name="password"
                      className="form-control"
                      id="exampleInputPassword1"
                      autoComplete="off"
                      placeholder="Password"
                      value={formData.password || ""}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="exampleInputPassword1" className="form-label">
                      Select Language
                    </label>

                    <select
                      className="mb-1 form-control"
                      onChange={(e) => handleLanguageSelect(e.target.value)}
                    >
                      <option value="" disabled selected>
                        Select Language
                      </option>
                      {languages.map((language) => (
                        <option key={language.id} value={language.id}>
                          {language.language_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <button type="submit" className="btn btn-primary me-2">
                    Submit
                  </button>
                  <button className="btn btn-secondary" onClick={ClicktoBack}>
                    Cancel
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
